<template>
    <h2 class="heading">{{report.reportType}} Workflow Details</h2>
    <div class="detail">
        <el-steps :active="current" finish-status="success" align-center style="width:100%;margin:15px 5px;" >
            <el-step v-for="(step, index) in steps" :title="step" :key="index" style="font-size:14px"/>
        </el-steps>
        <table>
            <tr><th>Report type</th>
                <td>{{report.reportType}}</td>
                <th>Report date</th>
                <td>{{report.reportDate}}</td>
                <th>Report status</th>
                <td>{{report.status}}</td>
            </tr>
        </table>

        <table>
            <tr v-if="report.reportType == 'APxJ' || report.reportType == 'Leaflet'"><th>Data files</th>
                <td colspan="5">
                    <span v-if="report.dataFiles && report.dataFiles.length" class="tag">
                        <template v-for="(item, index) in report.dataFiles.split(';')" :key="index">
                            <el-tag v-if="item.length"><a :href="item.split(':')[1]">{{item.split(':')[0]}}</a></el-tag>
                        </template>
                    </span>
                </td>
            </tr>
            <tr v-if="report.status != 'dataImport'">
                <th>Report {{report.reportFiles && report.reportFiles.length ? "files" : "links"}}</th>
                <td colspan="5">
                    <span v-if="report.reportFiles && report.reportFiles.length" class="tag">
                        <template v-for="(item, index) in report.reportFiles.split(';')" :key="index">
                            <el-tag v-if="item.length"><a :href="item.split(':')[1]">{{item.split(':')[0]}}</a></el-tag><br v-if="(index+1)%3==0"/>
                        </template>
                    </span>
                    <template v-else-if="report.reportType=='Factsheet'">
                        <span v-for="(etf, index) in ETFs" :key="index" class="links">
                            <a :href="DOMAIN+'/report?fundId='+etf.id+'&language=en'" target="_blank">factsheet-{{etf.ticker}}-en</a>
                            <a :href="DOMAIN+'/report?fundId='+etf.id+'&language=cn'" target="_blank">factsheet-{{etf.ticker}}-sc</a>
                            <a :href="DOMAIN+'/report?fundId='+etf.id+'&language=hk'" target="_blank">factsheet-{{etf.ticker}}-tc</a> &nbsp; 
                            <br/>
                        </span>
                    </template>
                    <template v-else-if="report.reportType=='Leaflet'">
                        <span v-for="(etf, index) in ETFs" :key="index" class="links">
                            <template v-if="etf.id != 'FRNA' && etf.id != 'CTB2' && etf.id != 'FTWA'">
                                <a :href="DOMAIN+'/leaflet?fundId='+etf.id+'&language=en'" target="_blank">leaflet-{{etf.ticker}}-en</a>
                                <a :href="DOMAIN+'/leaflet?fundId='+etf.id+'&language=cn'" target="_blank">leaflet-{{etf.ticker}}-sc</a>
                                <a :href="DOMAIN+'/leaflet?fundId='+etf.id+'&language=hk'" target="_blank">leaflet-{{etf.ticker}}-tc</a> &nbsp;
                                <br/>
                            </template>
                        </span>
                    </template>
                </td>
            </tr>
            <tr><th>Creator remarks</th>
                <td colspan="5">
                    <el-card shadow="always" v-for="(remark,index) in report.remarks" :key="index">{{remark}}</el-card>
                </td>
            </tr>
        </table>

        <table v-if="report.reportType != 'APxJ' && report.operationsComments && report.operationsComments.length">
            <tr><th>Operations' comments <br/>/ attachments</th>
                <td colspan="5">
                    <div >
                        <el-card shadow="always" v-for="(comment,index) in report.operationsComments" :key="index">
                            <span v-html="comment.remark"></span><br/>
                            <template v-for="(file, i) in comment.attachments" :key="i">
                                <a href="" @click.prevent="global.down(file.url, file.name)" class="tag">{{file.name}}</a> &nbsp; 
                            </template>
                        </el-card>
                    </div>
                </td>
            </tr>
        </table>

        <table v-if="report.reportType == 'APxJ' && report.status != 'new' && report.status != 'dataImport'">
            <tr><th>Investments' comments <br/>/ attachments</th>
                <td colspan="5">
                    <div >
                        <el-card shadow="always" v-for="(comment,index) in report.checkComments" :key="index">
                            <span v-html="comment.remark"></span><br/>
                            <template v-for="(file, i) in comment.attachments" :key="i">
                                <a href="" @click.prevent="global.down(file.url, file.name)" class="tag">{{file.name}}</a> &nbsp; 
                            </template>
                        </el-card>
                    </div>
                </td>
            </tr>
        </table>

        <table v-if="report.reportType == 'Leaflet' && report.checkComments && report.checkComments.length">
            <tr><th>Research's comments <br/>/ attachments</th>
                <td colspan="5">
                    <div >
                        <el-card shadow="always" v-for="(comment,index) in report.checkComments" :key="index">
                            <span v-html="comment.remark"></span><br/>
                            <template v-for="(file, i) in comment.attachments" :key="i">
                                <a href="" @click.prevent="global.down(file.url, file.name)" class="tag">{{file.name}}</a> &nbsp; 
                            </template>
                        </el-card>
                    </div>
                </td>
            </tr>
        </table>

        <table v-if="'approved|published|updating|updated'.indexOf(report.status) > -1 && 
                report.complianceComments && report.complianceComments.length">
            <tr><th>Compliance's comments <br/>/ attachments</th>
                <td colspan="5">
                    <div >
                        <el-card shadow="always" v-for="(comment,index) in report.complianceComments" :key="index">
                            <span v-html="comment.remark"></span><br/>
                            <template v-for="(file, i) in comment.attachments" :key="i">
                                <a href="" @click.prevent="global.down(file.url, file.name)" class="tag">{{file.name}}</a> &nbsp; 
                            </template>
                        </el-card>
                    </div>
                </td>
            </tr>
        </table>

        <table v-if="report.canVerify">
            <tr><th>Verify result</th>
                <td colspan="5">
                    <el-radio-group v-model="status">
                        <el-radio label="verified" class="verified"><span>Verified</span></el-radio>
                        <el-radio label="revising" class="revising"><span>Need to revise</span></el-radio>
                    </el-radio-group>
                </td>
            </tr>
            <tr><th>Operations' comments</th>
                <td colspan="5">
                    <el-input v-model="comments" type="textarea" />
                </td>
            </tr>
            <tr><th>Attachments</th>
                <td colspan="5" style="display:flex">
                    <div v-if="attachments.indexOf(':') > -1" style="display:block;">
                        <template v-for="item in attachments.split(';')" :key="item">
                            <el-tag v-if="item.length" @close="removeFile(item)" closable>
                                <a href="" @click.prevent="global.down(item.split(':')[1], item.split(':')[0])">{{item.split(':')[0]}}</a>
                            </el-tag>
                        </template>
                    </div>
                    <el-upload :action="global.upload_path" multiple :on-success="uploaded" 
                            :data="{type:'report', subType:report.reportType+'/'+report.reportDate}" :show-file-list="false" >
                        <el-button style="display:inline;margin-top:5px;" type="primary" plain>Browse</el-button>
                    </el-upload>
                </td>
            </tr>
        </table>

        <table v-if="report.canConfirm">
            <tr><th>Check result</th>
                <td colspan="5">
                    <el-radio-group v-model="status">
                        <el-radio label="confirmed" class="confirmed"><span>Confirmed</span></el-radio>
                        <el-radio label="notpass" class="notpass"><span>Need to modify</span></el-radio>
                    </el-radio-group>
                </td>
            </tr>
            <tr><th>{{report.reportType=='APxJ' ? "Investment's" : "Research's"}} comments</th>
                <td colspan="5">
                    <el-input v-model="comments" type="textarea" />
                </td>
            </tr>
            <tr><th>Attachments</th>
                <td colspan="5" style="display:flex">
                    <div v-if="attachments.indexOf(':') > -1" style="display:block;">
                        <template v-for="item in attachments.split(';')" :key="item">
                            <el-tag v-if="item.length" @close="removeFile(item)" closable>
                                <a href="" @click.prevent="global.down(item.split(':')[1], item.split(':')[0])">{{item.split(':')[0]}}</a>
                            </el-tag>
                        </template>
                    </div>
                    <el-upload :action="global.upload_path" multiple :on-success="uploaded" 
                            :data="{type:'report', subType:report.reportType+'/'+report.reportDate}" :show-file-list="false" >
                        <el-button style="display:inline;margin-top:5px;" type="primary" plain>Browse</el-button>
                    </el-upload>
                </td>
            </tr>
        </table>

        <table v-if="report.canApprove">
            <tr><th>Review result</th>
                <td colspan="5">
                    <el-radio-group v-model="status">
                        <el-radio label="approved" class="approved"><span>Approved</span></el-radio>
                        <el-radio label="updating" class="updating"><span>Need to amend</span></el-radio>
                    </el-radio-group>
                </td>
            </tr>
            <tr><th>Compliance's comments</th>
                <td colspan="5">
                    <el-input v-model="comments" type="textarea" />
                </td>
            </tr>
            <tr><th>Attachments</th>
                <td colspan="5" style="display:flex">
                    <div v-if="attachments.indexOf(':') > -1" style="display:block;">
                        <template v-for="item in attachments.split(';')" :key="item">
                            <el-tag v-if="item.length" @close="removeFile(item)" closable>
                                <a href="" @click.prevent="global.down(item.split(':')[1], item.split(':')[0])">{{item.split(':')[0]}}</a>
                            </el-tag>
                        </template>
                    </div>
                    <el-upload :action="global.upload_path" multiple :on-success="uploaded" 
                            :data="{type:'report', subType:report.reportType+'/'+report.reportDate}" :show-file-list="false" >
                        <el-button style="display:inline;margin-top:5px;" type="primary" plain>Browse</el-button>
                    </el-upload>
                </td>
            </tr>
        </table>

        <table v-if="report.canPublish">
            <tr><th>Upload Report PDFs</th>
                <td colspan="5">
                    <div v-if="attachments.indexOf(':') > -1" style="display:inline;">
                        <template v-for="(item, i) in attachments.split(';')" :key="item" >
                            <el-tag v-if="item.length" @close="removeFile(item)" closable>
                                <a href="" @click.prevent="global.down(item.split(':')[1], item.split(':')[0])">{{item.split(':')[0]}}</a>
                            </el-tag>
                            <br v-if="(i+1)%3==0"/>
                        </template>
                    </div>
                    <el-upload :action="global.upload_path" multiple :on-success="uploaded" 
                        :data="{type:'report', subType : report.reportType+'/'+report.reportDate}" :show-file-list="false" >
                        <el-button style="display:inline;margin:5px 10px;" type="primary" plain>Browse</el-button>
                    </el-upload>
                </td>
            </tr>
        </table>

        <table v-if="(report.canImport || report.canModify || report.canUpdate) && report.reportType=='APxJ'">
            <tr><th>Upload APxJ report</th>
                <td colspan="5">
                    <div v-if="attachments.indexOf(':') > -1" style="display:inline;">
                        <el-tag @close="removeFile(attachments)" closable>
                            <a v-if="attachments.length" href="" 
                                @click.prevent="global.down(attachments.split(':')[1], attachments.split(':')[0])">{{attachments.split(':')[0]}}</a>
                        </el-tag>
                    </div>
                    <el-upload :action="global.upload_path" limit="1" :on-success="uploaded" 
                            :data="{type:'report', subType: report.reportType+'/'+report.reportDate}" :show-file-list="false" >
                        <el-button style="display:inline;margin:5px 10px;" type="primary" plain>Browse</el-button>
                    </el-upload>
                </td>
            </tr>
        </table>

        <div v-if="errMsg != ''" style="width:1024px;margin-top:15px;"><el-alert :title="errMsg" type="error" /></div>
        <div class="buttonDIV">
            <el-button v-if="report.canImport" type="primary" @click="importData">
                {{ report.reportType=='Leaflet' ? 'Data have been imported' : 'Upload APxJ report'}}
            </el-button>
            <el-button v-if="report.canRevise" type="primary" @click="reviseData">
                All data have been revised
            </el-button>
            <el-button v-if="report.canUpdate" type="primary" @click="updateReport">
                I have updated all
            </el-button>
            <el-button v-if="report.canModify" type="primary" @click="modifyReport">
                I have modified all
            </el-button>
            <el-button v-if="report.canVerify" type="primary" @click="verfiyReport">
                Submit verify
            </el-button>
            <el-button v-if="report.canConfirm" type="primary" @click="confirmReport">
                Submit confirm
            </el-button>
            <el-button v-if="report.canApprove" type="primary" @click="approveReport">
                Submit approve
            </el-button>
            <el-button v-if="report.canPublish" type="primary" @click="publishReport">
                Upload report PDFs
            </el-button>
            <el-button @click="$router.push('/report/reportList?reportType=' + report.reportType)">Back to report list</el-button>
            <span v-if="loading" style="display:inline-block; margin-left:20px; vertical-align:middle;">
                <img src="@/assets/loading.gif" style="height:24px;"/>
            </span>
        </div>
    </div>
</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'

export default {
    data() {
        return {
            DOMAIN: 'https://etfprod.premia-partners.com',
            ETFs: [ 
                {id:'CXBS', ticker:'2803'},
                {id:'CXNE', ticker:'3173'},
                {id:'AITE', ticker:'3181'},
                {id:'EATE', ticker:'2810'},
                {id:'MVTE', ticker:'2804'},
                {id:'FRNE', ticker:'3077'},
                {id:'FRNA', ticker:'9078'},
                {id:'CTBE', ticker:'2817'},
                {id:'CPBE', ticker:'3001'},
                {id:'STRE', ticker:'3151'},
                {id:'CTB2', ticker:'9177'},
				{id:'JPBE', ticker:'3411'},
				{id:'FTWE', ticker:'3453'},
				{id:'FTWA', ticker:'9159'},
                {id:'SUKE', ticker:'3478'}
            ],
            comments: '',
            attachments: '',
            report: { reportType : ''},
            status: null,
            errMsg: '',
            code: null,
            current: 0,
            steps: [],
            loading: false,
            c: 0,
            global,
        }
    },
    computed: {
    },
    async mounted() {
        this.code = this.$route.query.code;
        let result = await AXIOS("/report/reportDetail", {code: this.code});
        if (result.success) {
            this.report = result.data;
        } else {
            this.errMsg = result.errMsg;
        }
        this.global.index = "report-" + this.report.reportType;

        result = await AXIOS("/report/getReportSteps", {code: this.code});
        if (result.success) {
            this.steps = result.data.steps;
            this.current = result.data.current;
        } else {
            this.errMsg = result.errMsg;
        }
    },
    methods: {
        async importData() {
            let data = {code: this.code};
            if (this.report.reportType == 'APxJ') {
                if (this.attachments == '') {
                    this.errMsg = "Please upload 'Upload APxJ report'"; return;
                }
                data["attachments"] = this.attachments;
            }
            if (this.loading) return; //avoid repeat submit
            this.loading = true;
            let result = await AXIOS("/report/importData", data);
            if (result.success) {
                this.$router.push("/report/reportList?reportType="+this.report.reportType)
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        },
        async reviseData() {
            if (this.loading) return; //avoid repeat submit
            this.loading = true;
            let result = await AXIOS("/report/reviseData", {code: this.code});
            if (result.success) {
                this.$router.push("/report/reportList?reportType="+this.report.reportType)
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        },
        async updateReport() {
            let data = {code: this.code};
            if (this.report.reportType == 'APxJ') {
                if (this.attachments == '') {
                    this.errMsg = "Please upload 'Upload APxJ report'"; return;
                }
                data["attachments"] = this.attachments;
            }
            if (this.loading) return; //avoid repeat submit
            this.loading = true;
            let result = await AXIOS("/report/updateReport", data);
            if (result.success) {
                this.$router.push("/report/reportList?reportType="+this.report.reportType)
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        },
        async modifyReport() {
            let data = {code: this.code};
            if (this.report.reportType == 'APxJ') {
                if (this.attachments == '') {
                    this.errMsg = "Please upload 'Upload APxJ report'"; return;
                }
                data["attachments"] = this.attachments;
            }
            if (this.loading) return; //avoid repeat submit
            this.loading = true;
            let result = await AXIOS("/report/modifyReport", data);
            if (result.success) {
                this.$router.push("/report/reportList?reportType="+this.report.reportType)
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        },
        async verfiyReport() {
            if (this.status == null) {
                this.errMsg = "Please select 'Verify result'"; return;
            }
            if (this.status == 'revising' && this.comments == '') {
                this.errMsg = "Please input 'Operations' comments'"; return;
            }

            if (this.loading) return; //avoid repeat submit
            this.loading = true;
            let data = {code:this.code, status:this.status, comments:this.comments, attachments:this.attachments};
            let result = await AXIOS("/report/verfiyReport", data);
            if (result.success) {
                this.$router.push("/report/reportList?reportType="+this.report.reportType)
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        },
        async confirmReport() {
            if (this.status == null) {
                this.errMsg = "Please select 'Check result'"; return;
            }
            if (this.status == 'notpass' && this.comments == '') {
                this.errMsg = "Please input 'Research's comments'"; return;
            }

            if (this.loading) return; //avoid repeat submit
            this.loading = true;
            let data = {code:this.code, status:this.status, comments:this.comments, attachments:this.attachments};
            let result = await AXIOS("/report/confirmReport", data);
            if (result.success) {
                this.$router.push("/report/reportList?reportType="+this.report.reportType)
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        },
        async approveReport() {
            if (this.status == null) {
                this.errMsg = "Please select 'Review result'"; return;
            }
            if (this.status == 'updating' && this.comments == '') {
                this.errMsg = "Please input 'Compliance's comments'"; return;
            }

            if (this.loading) return; //avoid repeat submit
            this.loading = true;
            let data = {code:this.code, status:this.status, comments:this.comments, attachments:this.attachments};
            let result = await AXIOS("/report/approveReport", data);
            if (result.success) {
                this.$router.push("/report/reportList?reportType="+this.report.reportType)
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        },
        async publishReport() {
            if (this.attachments == '') {
                this.errMsg = "Please upload PDF reports"; return;
            }
            if (this.loading) return; //avoid repeat submit
            this.loading = true;
            let data = {code:this.code, attachments:this.attachments};
            let result = await AXIOS("/report/publishReport", data);
            if (result.success) {
                this.$router.push("/report/reportList?reportType="+this.report.reportType)
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        },
        uploaded(response) {
            let files = response.length ? response[0].name + ":" + response[0].url : '';
            if (files != '' && this.attachments.indexOf(files) == -1) {
                this.attachments = (this.attachments == '') ? files : this.attachments + ";" + files;
            }
        },
        removeFile(item) {
            this.attachments = this.attachments + ";"
            this.attachments = this.attachments.replace(item+";", "");
            if (this.attachments.endsWith(";")) {
                this.attachments = this.attachments.substring(0, this.attachments.length-1);
            }
        },
    }
}
</script>

<style scoped>
    .heading {
        width:1054px;
    }
    .buttonDIV {
         width:1000px;
    }
    .detail table {
        width:1000px;
        margin-left:60px;
        margin-bottom: 10px;
    }
    .detail th {
        background: #f5f5f5; 
        width: 160px; 
    }
    .el-card {margin-top:8px;}
    .el-tag {margin: 5px 10px; padding:5px 5px 5px 10px; line-height:1.5em; height:30px; font-size:14px;}
    .el-tag a {text-decoration: none;}
    .revising, .updating, .notpass {color:#D00; font-weight: bold;}
    .approved, .verified, .confirmed {color:#083; font-weight: bold;}
    td.rejected { background:#ffeeee; }
    td.approved { background:#f5fffa; }
    td.new { background:#eff; color:#06B;font-weight: bold;}
    .links a {margin-right:5px; display:inline-block; padding:5px 5px; color:rgb(0, 102, 204); text-decoration:none; font-size:14px;}
	.links a:hover { color:#409eff; text-decoration:underline; color:#01b1af;}
</style>
<style>
    .d, .date {color:#aaa !important;}
    .el-card {margin-top:8px; line-height:1.5em;}
</style>